module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-info-container"
  }, [_c('div', {
    staticClass: "side-info",
    staticStyle: {
      "top": "132px",
      "left": "0"
    }
  }, [_c('p', [_vm._v("\n      Votre message, d’une durée de 6 secondes, sera intégré dans chaque boucle. Il sera diffusé 500 fois par jour, soit 1 fois toutes les boucles.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Attention, un certain nombre de produits sont soumis à une législation stricte et nécessitent l'intégration de mentions légales et sanitaires sur une surface représentant au moins 20% du visuel. Vous êtes tenus de connaître et respecter les lois en vigueur, notamment pour la publicité concernant l’alcool, le tabac, les jeux d'argent et l'alimentation.\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default btn-side-info",
    attrs: {
      "to": "/miscellanous/mentions-legales",
      "id": "mentions-legales"
    }
  }, [_vm._v("\n      CONSULTER LES MENTIONS OBLIGATOIRES\n    ")])], 1), _vm._v(" "), _c('svg', {
    staticClass: "oblique-side-bar-left",
    attrs: {
      "data-name": "oblique",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "577",
      "height": "1460.4",
      "viewBox": "0 0 577 1460.4"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": "side-info-gradient",
      "x1": "0",
      "x2": "0",
      "y1": "0",
      "y2": "1"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": _vm.gradientColor
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "55%",
      "stop-color": "black",
      "stop-opacity": "0"
    }
  })], 1), _vm._v(" "), _c('pattern', {
    attrs: {
      "id": "side-info-background",
      "patternUnits": "userSpaceOnUse",
      "width": "1000",
      "height": "2500"
    }
  }, [_c('image', {
    staticClass: "trad-features",
    attrs: {
      "href": _vm.background,
      "x": _vm.left,
      "y": _vm.top,
      "width": _vm.size,
      "height": _vm.size
    }
  })])], 1), _vm._v(" "), _c('title', [_vm._v("side-info")]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "myClip"
    }
  }, [_c('polygon', {
    attrs: {
      "transform": "translate(30,-200)",
      "points": "577 1460.4 0 1460.4 0 0 330.7 0 577 1460.4"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "clip-path": "url(#myClip)"
    }
  }, [_c('rect', {
    staticClass: "trad-features",
    attrs: {
      "x": "0",
      "y": "0",
      "width": "600",
      "height": "2000",
      "fill": "url(#side-info-background)"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "trad-features",
    attrs: {
      "x": "0",
      "y": "0",
      "width": "600",
      "height": "2000",
      "fill": "url(#side-info-gradient)"
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-92851d7e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92851d7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideInfo.vue
// module id = 199
// module chunks = 1